<div class="xi-modal__container" *transloco="let t; prefix: 'widgets.publish-insight-dialog'">
  <h2 class="xi-modal__title kxi-text-center">
    {{ t(insight().published ? 'edit-insight' : 'publish-insight') }}
  </h2>

  <form [formGroup]="publishInsightForm">
    <div class="xi-modal__content">
      <div class="publish-insight__field-wrapper">
        <label class="publish-insight__label" for="question">{{ t('question-title') }}</label>
        <xi-input-field
          name="question"
          inputId="question"
          formControlName="question"
          [status]="questionStatus"
        ></xi-input-field>
      </div>

      <div class="publish-insight__field-wrapper">
        <label class="publish-insight__label" for="insight">{{ t('insight') }}</label>
        <xi-text-area
          type="text"
          inputId="insight"
          formControlName="insight"
          [status]="insightStatus"
        ></xi-text-area>
      </div>
      <div class="publish-insight__grid">
        <div class="publish-insight__include-image">
          <xi-checkbox
            [label]="t('include-chart-image')"
            formControlName="includeImage"
          ></xi-checkbox>
        </div>

        <label class="publish insight__comment-label publish-insight__label" for="comment">{{
          t('comment')
        }}</label>

        <div class="publish-insight__image">
          @if (imageExists()) {
            @if (isImageLoading()) {
              <div class="xi-loader-container__inline-overlay">
                <xi-animation
                  [height]="75"
                  [width]="75"
                  [loop]="true"
                  animation="cx_loader"
                ></xi-animation>
              </div>
            } @else {
              <img [src]="insightImage()" [alt]="t('chart-image')" />
            }
          }
        </div>

        <div class="publish-insight__comment">
          <xi-text-area
            type="text"
            inputId="comment"
            formControlName="comment"
            [status]="commentStatus"
          ></xi-text-area>
        </div>

        <div class="public-insight__tags">
          <div class="project-panel__content-item-wrapper">
            <h3 class="kxi-text-normal kxi-text-600">
              {{ t('tags-n', { count: insightLabels.length }) }}
            </h3>

            <app-item-labels
              [item]="{
                type: 'insight',
                id: insight().insight_id,
                labels: insightLabels,
                searchLabels: searchLabels,
              }"
              (labelApplied)="onLabelApplied($event)"
              (labelRemoved)="onLabelRemoved($event)"
              (labelUpdated)="onLabelUpdated($event)"
            ></app-item-labels>
          </div>
        </div>
      </div>
    </div>

    <div class="xi-modal__actions publish-insight__actions">
      <xi-default-button
        [text]="t('cancel')"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>

      <xi-default-button
        [text]="t(insight().published ? 'update' : 'publish')"
        [disabled]="publishInsightForm.status !== 'VALID'"
        (onClick)="onPublish()"
      ></xi-default-button>
    </div>
  </form>
</div>
